/**
 * SOLA ⚡️ A página de produto no celular.
 *
 * Duas coisas que o Rafa pediu em 15/10, as duas só no celular:
 *
 * 1. A SEÇÃO DE REMESSA SOBE para logo abaixo do produto, em QUALQUER
 *    largura -- o Rafa confirmou em 15/10 que é para valer no desktop
 *    também, acima da seção de escolha da caixa. Hoje ela cai depois das
 *    seções de estilo e quem está decidindo a compra não chega nela.
 *    A ordem das seções mora no template JSON, que é do Zeca e não se
 *    sobrescreve por push; por isso a troca acontece aqui, no navegador.
 *    O JSON continua exatamente como ele deixou.
 *
 * 2. AO TROCAR DE VARIANTE, a galeria volta para a vista. No celular o
 *    seletor fica abaixo da foto: a pessoa escolhe o mostrador, escolhe a
 *    caixa, e nunca vê o que escolheu -- a foto mudou fora da tela.
 *
 * Se este arquivo não carregar, a página fica como era. Nada aqui é
 * necessário para comprar.
 */
(function () {
  'use strict';

  var CELULAR = '(max-width: 767px)';
  var naTela = window.matchMedia(CELULAR);
  function ehCelular() { return naTela.matches; }

  /* ---------------- 1. a ordem das seções ---------------- */

  var secaoRemessa = null;

  function acharRemessa() {
    var dentro = document.querySelector('#MainContent .sola-batches');
    return dentro ? dentro.closest('[id^="shopify-section"]') : null;
  }

  function acharProduto() {
    /* Em template JSON a seção principal vira `...__main`. O segundo seletor
       cobre o tema montado à mão, onde o id é só `shopify-section-main`. */
    return document.querySelector('#MainContent > [id^="shopify-section"][id$="__main"]')
        || document.getElementById('shopify-section-main')
        || (function () {
             var info = document.querySelector('#MainContent product-info, #MainContent .product');
             return info ? info.closest('[id^="shopify-section"]') : null;
           })();
  }

  function arrumarOrdem() {
    if (!secaoRemessa || !secaoRemessa.parentNode) return;
    var produto = acharProduto();
    if (!produto || produto === secaoRemessa) return;
    if (produto.parentNode !== secaoRemessa.parentNode) return;
    if (produto.nextElementSibling === secaoRemessa) return;
    produto.insertAdjacentElement('afterend', secaoRemessa);
  }

  /* ---------------- 2. a galeria volta para a vista ---------------- */

  function galeria() {
    var todas = document.querySelectorAll('#MainContent [id^="MediaGallery-"]');
    for (var i = 0; i < todas.length; i++) {
      /* `offsetParent` nulo = escondida. O tema troca a seção do produto por
         fetch e pode deixar a anterior no DOM com display:none; medir essa
         daria zero em tudo e a conta da rolagem sairia errada. */
      if (todas[i].offsetParent) return todas[i];
    }
    return todas[0] || null;
  }

  /* O cabeçalho grudado cobriria o topo da foto. Só conta se estiver mesmo
     grudado -- em alguns temas ele só fica sticky acima de certa largura. */
  function alturaDoCabecalho() {
    var topo = document.querySelector('sticky-header, .header-wrapper, header');
    if (!topo) return 0;
    var pos = getComputedStyle(topo).position;
    return (pos === 'sticky' || pos === 'fixed') ? topo.offsetHeight : 0;
  }

  var ultimaRolagem = 0;

  function mostrarGaleria() {
    if (!ehCelular()) return;
    var g = galeria();
    if (!g) return;

    /* SEM ESPERTEZA AQUI.
       A primeira versão só rolava quando a galeria estava inteira fora da
       tela ("se dá para ver um pedaço, não mexe"). Na mão do Rafa em 15/10
       isso deu o pior resultado possível: funcionava uma vez e depois não
       mais. O motivo é que, parado na altura do seletor de caixa, sobra uma
       tira da foto visível no topo -- o suficiente para a trava desistir, e
       insuficiente para a pessoa ver o relógio que acabou de escolher.
       Agora a regra é só uma: toda troca de variante traz a galeria para o
       topo. Se ela já estiver lá, não há rolagem nenhuma de qualquer forma. */
    var topoIdeal = alturaDoCabecalho() + 8;
    var destino = Math.max(0, window.pageYOffset + g.getBoundingClientRect().top - topoIdeal);
    if (Math.abs(window.pageYOffset - destino) < 24) return;

    /* Trocar de variante dispara mais de um aviso (pub/sub, change, click).
       A trava evita três rolagens empilhadas, mas é curta: duas trocas
       seguidas de verdade têm que funcionar as duas. */
    if (Date.now() - ultimaRolagem < 250) return;
    ultimaRolagem = Date.now();

    window.scrollTo({ top: destino, behavior: 'smooth' });

    /* No celular a rolagem suave é interrompida quando o dedo ainda está na
       tela, e aí ela simplesmente não acontece. Confere depois e insiste uma
       vez, sem animação. */
    setTimeout(function () {
      var g2 = galeria();
      if (!g2) return;
      var alvo = Math.max(0, window.pageYOffset + g2.getBoundingClientRect().top - (alturaDoCabecalho() + 8));
      if (Math.abs(window.pageYOffset - alvo) > 60) window.scrollTo(0, alvo);
    }, 650);
  }

  /* ---------------- ligações ---------------- */

  function comecar() {
    secaoRemessa = acharRemessa();
    arrumarOrdem();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', comecar);
  } else {
    comecar();
  }

  if (naTela.addEventListener) naTela.addEventListener('change', arrumarOrdem);
  else if (naTela.addListener) naTela.addListener(arrumarOrdem);

  /* O tema avisa a troca de variante por pub/sub (global.js). É o aviso mais
     confiável, mas nem toda troca passa por ele: o bloco do produto às vezes
     é substituído inteiro por fetch. Por isso os dois ouvintes abaixo
     também existem -- a trava de tempo impede que virem três rolagens. */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(function () { arrumarOrdem(); mostrarGaleria(); }, 80);
      });
    }
  } catch (e) { /* tema sem pub/sub: os ouvintes abaixo dão conta */ }

  var dentroDoSeletor = 'product-variant-selects, .product__variant-options, variant-selects, .product-form__input';

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest(dentroDoSeletor)) {
      setTimeout(mostrarGaleria, 180);
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(dentroDoSeletor)) {
      /* Mais folgado que o `change`: o tema troca a foto depois de buscar a
         seção, e rolar antes disso levaria a pessoa para a foto antiga. */
      setTimeout(mostrarGaleria, 320);
    }
  }, true);
})();
